export const I18N_LOCALE_DEFAULT = "en";

export const I18N_LOCALES = [I18N_LOCALE_DEFAULT, "ru"] as const;

export const I18N_LOCALE_STORAGE_KEY = "i18n-locale";
